import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "testify-flex testify-min-h-[60px] testify-w-full testify-rounded-md testify-border testify-border-input testify-bg-transparent testify-px-3 testify-py-2 testify-text-sm testify-shadow-sm testify-placeholder:text-muted-foreground testify-focus-visible:outline-none testify-focus-visible:ring-1 testify-focus-visible:ring-ring testify-disabled:cursor-not-allowed testify-disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
